import axios from "axios";

export const getAll = () => {
    return axios.get("/api/services/app/SpecialGroup/GetAllForAdmin");
};

export const getActive = () => {
    return axios.get("/api/services/app/SpecialGroup/GetActive");
};

export const getById = (id) => {
    return axios.get("/api/services/app/SpecialGroup/Get", { params: { id } });
};

export const create = (specialGroup) => {
    return axios.post("/api/services/app/SpecialGroup/Create", specialGroup);
};

export const update = (specialGroup) => {
    return axios.put("/api/services/app/SpecialGroup/Update", specialGroup);
};

export const deactivate = (id) => {
    return axios.post("/api/services/app/SpecialGroup/Deactivate", null, { params: { id } });
};

export const reactivate = (id) => {
    return axios.post("/api/services/app/SpecialGroup/Reactivate", null, { params: { id } });
};

export const validateStudentSpecialGroupImport = (documentId) => {
    return axios.post("/api/services/app/SpecialGroup/ValidateStudentSpecialGroupImport", { id: documentId });
};

export const importStudentSpecialGroups = (documentId) => {
    return axios.post("/api/services/app/SpecialGroup/ImportStudentSpecialGroups", { id: documentId });
};
